import Icon from '../../../../components/AppIcon';

const PatientTab = ({ order }) => {
  const patient = order.patient;
  console.log("patient",patient)

  if (!patient) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
        <Icon name="User" size={24} className="mx-auto mb-3 text-gray-300" />
        <p className="text-xs text-gray-500">No patient information available</p>
        <p className="text-xs text-gray-400 mt-1">Patient details were not provided</p>
      </div>
    );
  }


  const primaryInfo = [
    { 
      icon: 'User', 
      label: 'Full Name', 
      value: patient.fullName,
      size: 'md' 
    },
    { 
      icon: 'Phone', 
      label: 'Contact', 
      value: patient.contactNo,
      copyable: true
    },
    { 
      icon: 'Mail', 
      label: 'Email', 
      value: patient.email || 'Not provided',
      copyable: true
    },
  ];

  const secondaryInfo = [
    { 
      icon: 'Users', 
      label: 'Gender', 
      value: patient.gender ? patient.gender.charAt(0).toUpperCase() + patient.gender.slice(1) : '—'
    },
    { 
      icon: 'Calendar', 
      label: 'Date of Birth', 
      value: patient.dob ? new Date(patient.dob).toLocaleDateString('en-IN') : '—',
      subtext: patient.dob ? `Age: ${calculateAge(patient.dob)}` : null
    },
    { 
      icon: 'FileText', 
      label: 'Patient ID', 
      value: patient.id || '—'
    },
  ];

  // Calculate age from DOB
  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return `${age} years`;
  }

  return (
    <div className="space-y-4">
      {/* Patient Header Card */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="relative">
            <div className="h-10 w-10 bg-blue-50 rounded-lg flex items-center justify-center border border-blue-100">
              <Icon name="User" size={18} className="text-blue-600" />
            </div>
            {patient.isSenior && (
              <span className="absolute -top-1 -right-1 bg-amber-100 text-amber-800 text-[10px] font-medium px-1.5 py-0.5 rounded-full">
                60+
              </span>
            )}
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900">{patient.fullName}</h3>
            <p className="text-xs text-gray-500">
              Patient ID: {patient.id || 'N/A'} • 
              {patient.relationship ? ` ${patient.relationship}` : ' Self'}
            </p>
          </div>
          <button className="text-xs text-blue-600 hover:text-blue-700 font-medium px-3 py-1.5 border border-blue-200 rounded-md hover:bg-blue-50 transition-colors">
            <Icon name="Edit" size={12} className="inline mr-1.5" />
            Edit
          </button>
        </div>

       
      </div>

      {/* Contact Information */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-3">Contact Information</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {primaryInfo.map((item, i) => (
            <div key={i} className={`flex items-center gap-3 p-2.5 bg-gray-50/50 rounded-md border border-gray-100 hover:bg-gray-50 transition-colors ${item.size === 'md' ? 'md:col-span-2' : ''}`}>
              <div className="p-1.5 bg-white rounded border border-gray-200 flex-shrink-0">
                <Icon name={item.icon} size={14} className="text-gray-500" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 mb-0.5">{item.label}</p>
                <div className="flex items-center gap-2">
                  <p className="text-sm font-medium text-gray-900 truncate">{item.value}</p>
                  {item.copyable && (
                    <button className="text-gray-400 hover:text-gray-600 transition-colors">
                      <Icon name="Copy" size={12} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Personal Details */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-3">Personal Details</h4>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {secondaryInfo.map((item, i) => (
            <div key={i} className="bg-gray-50/50 rounded-md p-3 border border-gray-100">
              <div className="flex items-center gap-2 mb-1.5">
                <Icon name={item.icon} size={12} className="text-gray-400" />
                <p className="text-xs text-gray-500">{item.label}</p>
              </div>
              <p className="text-sm font-medium text-gray-900">{item.value}</p>
              {item.subtext && (
                <p className="text-xs text-gray-400 mt-0.5">{item.subtext}</p>
              )}
            </div>
          ))}
          
          {/* Additional Information */}
          {patient.bloodGroup && (
            <div className="bg-gray-50/50 rounded-md p-3 border border-gray-100">
              <div className="flex items-center gap-2 mb-1.5">
                <Icon name="Droplet" size={12} className="text-gray-400" />
                <p className="text-xs text-gray-500">Blood Group</p>
              </div>
              <p className="text-sm font-medium text-gray-900">{patient.bloodGroup}</p>
            </div>
          )}
          
          {patient.emergencyContact && (
            <div className="bg-gray-50/50 rounded-md p-3 border border-gray-100 md:col-span-2">
              <div className="flex items-center gap-2 mb-1.5">
                <Icon name="AlertCircle" size={12} className="text-gray-400" />
                <p className="text-xs text-gray-500">Emergency Contact</p>
              </div>
              <p className="text-sm font-medium text-gray-900">{patient.emergencyContact}</p>
              <p className="text-xs text-gray-400 mt-0.5">{patient.emergencyRelation || 'Family Member'}</p>
            </div>
          )}
        </div>
      </div>

    
     
    </div>
  );
};

export default PatientTab;